// register component(s) with react habitat
import codeSplit from '@src/scripts/higher-order-components/codeSplit';

export default {
	StickyChat: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "StickyChat" */
				'./index'
			),
	} ),
};
